<header>
  <div *ngIf="userLogged">
    <mat-toolbar>
      <button *ngIf="isMobile" mat-icon-button (click)="openNoBackdrop(content)"  type="button">
       <mat-icon>menu</mat-icon>
      
      </button>
      <ng-template #content let-offcanvas>
        <div class="offcanvas-header">
          <img [src]="photo" class="photoUser rounded-circle m-1" alt="img">
          <h4 class="offcanvas-title">
            {{nameUser}}
          </h4>
          <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
        </div>
        <div class="offcanvas-body">
          <div class="d-flex flex-column">
            <button mat-button class="align-self-start" (click)="showMinorsProfile(); offcanvas.dismiss('Cross click')"><mat-icon>people</mat-icon> <span [innerHTML]="('label.minorProfiles' | translation)"></span></button>
            <button mat-button class="align-self-start" (click)="showMyProfile(); offcanvas.dismiss('Cross click')"><mat-icon>person</mat-icon> <span [innerHTML]="('label.myProfile' | translation)"></span></button>
            <div class="d-inline-block" placement="bottom-end" display="dynamic" ngbDropdown #langs="ngbDropdown">
              <div ngbDropdownMenu aria-labelledby="dropdownManual" id="langs">
                <div *ngFor="let lng of listOfLanguages">
                  <button mat-button (click)="changeLanguage(lng.value)" [innerHTML]="lng.valueView | translation"></button>
                </div>
              </div>
            </div>
            <button class="m-1 align-self-start" mat-button (click)="$event.stopPropagation(); langs.open()">
              <mat-icon>translate</mat-icon><span [innerHTML]="language|translation">italiano</span>
            </button>
            <div *ngIf="( this.tutorService.minorsStatus$ |async) as status">
              <div class="d-inline-block" placement="bottom-end" display="dynamic" ngbDropdown #notify="ngbDropdown">
                <div ngbDropdownMenu aria-labelledby="dropdownManual" id="notify">
                  <h3 class="m-2">{{'usertoenabled' | translation}}</h3>
                  <div *ngFor="let st of status.emailList">
                    <div class="d-flex justify-content-start" *ngIf="st.pending || !st.active">
                      <div class="m-2" [ngClass]="st.pending?'pending':'anactive'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-person-fill" viewBox="0 0 16 16">
                          <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                        </svg>
                      </div>
                      <span class="m-2" [innerHTML]="st.email"></span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="m-1 align-self-start" mat-button (click)="$event.stopPropagation(); notify.open()">
                <mat-icon [matBadge]="status.counter" matBadgeColor="warn">email</mat-icon><span class="ml-3"  [innerHTML]="'Notify'|translation"></span>
              </button>
            </div>
            <button mat-button class="align-self-start" (click)="logout(); offcanvas.dismiss('Cross click')"><mat-icon>logout_outlined</mat-icon> Log Out</button>

          </div>

        </div>
      </ng-template>
      <img class="logo" alt="Panini's Logo" src="../assets/imgs/Panini.png" />
      <ng-container *ngIf="!isMobile">
        <span class="spacer"></span>
        <button class="m-1" [matMenuTriggerFor]="langsMenu" mat-button>
          <span [innerHTML]="language|translation">italiano</span>
        </button>
        <mat-menu #langsMenu="matMenu" xPosition="before">
          <div *ngFor="let lng of listOfLanguages">
            <button mat-menu-item (click)="changeLanguage(lng.value)" [innerHTML]="lng.valueView | translation"></button>
          </div>
        </mat-menu>
        <div *ngIf="( this.tutorService.minorsStatus$ |async) as status">
          <button mat-icon-button class="m-1" [matMenuTriggerFor]="alertsMenu"
            aria-label="Example icon-button with share icon">
            <mat-icon [matBadge]="status.counter" matBadgeColor="warn">email</mat-icon>
          </button>
          <mat-menu class="alertsMenu" #alertsMenu="matMenu" xPosition="before">
            <h3 class="m-2">{{'usertoenabled' | translation}}</h3>
            <div *ngFor="let st of status.emailList">
              <div class="d-flex justify-content-start" *ngIf="st.pending || !st.active">
                <div class="m-2" [ngClass]="st.pending?'pending':'anactive'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-person-fill" viewBox="0 0 16 16">
                    <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                  </svg>
                </div>
                <span class="m-2" [innerHTML]="st.email"></span>
              </div>
            </div>
          </mat-menu>
        </div>
  
        <img [src]="photo" class="photoUser rounded-circle m-1" alt="img">
        <span class="small">{{nameUser}}</span>
        <button mat-icon-button [matMenuTriggerFor]="userMenu" class="example-icon"
          aria-label="Example icon-button with share icon">
          <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #userMenu="matMenu" xPosition="before">
          <button mat-menu-item (click)="showMinorsProfile()"><mat-icon>people</mat-icon> <span [innerHTML]="('label.minorProfiles'|translation)"></span></button>
          <button mat-menu-item (click)="showMyProfile()"><mat-icon>person</mat-icon> <span [innerHTML]="('label.myProfile'|translation)"></span></button>
          <button mat-menu-item (click)="logout()"><mat-icon>logout_outlined</mat-icon> Log Out</button>
        </mat-menu>
      </ng-container >
  
    </mat-toolbar>
  </div>
</header>
<main class="container-fluid" role="main">
  <router-outlet></router-outlet>
  <app-toast aria-live="polite" aria-atomic="true"></app-toast>
  <app-ngx-spinner></app-ngx-spinner>
</main>
<footer>
  <div class="socialsContainer text-center">
    <a href="https://www.facebook.com/figurinepanini/">
      <img alt="Facebook's Logo" class="socialIcon" src="../assets/imgs/Facebook_Logo_Secondary.png" />
    </a>
    <a href="https://twitter.com/figurinepanini">
      <img alt="X's Logo" class="socialIcon" src="../assets/imgs/x-logo.png" />
    </a>
    <a href="https://www.instagram.com/figurinepanini/">
      <img alt="Instagram's Logo" class="socialIcon" src="../assets/imgs/Instagram_Glyph_White.png" />
    </a>
    <a href="https://www.youtube.com/user/panini">
      <img alt="YouTube's Logo" class="socialIconYt" src="../assets/imgs/yt_logo_mono_dark.png" />
    </a>
  </div>
  <div class="policiesPanini">
    <div class="container text-center">
     <div id="pnn-footer" [attr.data-locale]="this.langFooter" data-statement="hq" data-privacy="legal-guardians" data-conditions="legal-guardians" data-accessibility="legal-guardians"></div>
      <a id="cookierenew" (click)="cookiebotRenew()"><span class="cookie-icon">
          <img alt="cookies" src="../assets/imgs/cookie-bite-solid.svg" />
        </span><span class="cookie-text">Gestisci i cookie</span></a>
    </div>
  </div>
</footer>